<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Laporan Iuran
      <!-- <CButton color="info" class="btn-md ml-auto">Ekspor Excel</CButton>         -->
    </CCardHeader>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keanggotaan/pengaturan-iuran"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#data-anggota"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
        >          
          Pengaturan Iuran 
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keanggotaan/laporan-iuran"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="home-tab"
          data-toggle="tab"
          href="#data-anggota"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
        >
          Laporan Iuran
        </router-link>
      </li>
      <li class="nav-item">
          <router-link
            to="/keanggotaan/outstanding-iuran"
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"            
            id="home-tab"
            data-toggle="tab"            
            href="#data-anggota"
            role="tab"
            aria-controls="data-anggota"
            aria-selected="true"
          >Outstanding Iuran</router-link>
      </li>
    </ul>      
    <CCardBody>      
    <!-- Filter -->
    <CRow>      
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Periode</label>
          <multiselect
            class="multi-select"
            label="tahun"
            placeholder="Pilih Periode"
            :show-labels="false"            
            :options="optionsPeriode"
            v-model="formFilter.periode"            
          ></multiselect>                     
        </div>
      </div>
      <div class="col-sm-12 col-xl-6" >
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Kategori Anggota</label>
          <multiselect
            class="multi-select"
            label="namaKategori"
            placeholder="Pilih Kategori Anggota"
            :show-labels="false"            
            :options="optionKategoriAnggotaFilter"
            v-model="formFilter.kategori"            
          ></multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-12">
        <div style="float:right">
          <button class="btn btn-info mr-2" @click="resetFilter">Reset Filter</button>
          <button class="btn btn-success" @click="filterData">Terapkan</button>
        </div>
      </div>     
    </CRow>
    <br>    
    <!-- filter -->
    <CRow>
      <div class="col-sm-12 col-xl-2">
        <div class="form-group">
          <label for>Data Perhalaman</label>            
          <select class="form-control" name="pageSize" id="pageSize" @change="changePageSize">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="100">100</option>
            <option value="Semua Data">Semua Data</option>
          </select>
        </div>
      </div>        
      <div class="col-sm-12 col-xl-3 ml-auto">
        <div class="form-group">
          <label for>Pencarian</label>
          <input type="text" name id class="form-control" placeholder="Cari Data ..." v-model.trim="search"  />
        </div>
      </div>
    </CRow>
    <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center p-0 border-0">
      <ul class="nav nav-tabs bg-primary border-0" id="myTab" role="tablist">           
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_belum_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white' "
            id="profile"
            data-toggle="tab"
            href="#profile"
            :style="tab_selected.aria_selected_belum_lunas ?'cursor: pointer;background-color:rgb(72, 107, 167)': 'cursor: pointer'"
            role="tab"
            aria-controls="profile"
            @click="tabchange('belum_lunas')"
            :aria-selected="tab_selected.aria_selected_belum_lunas"
            >
              Belum Lunas 
              <span class="badge ml-1 badge-danger text-white">{{ total_element_belum }}</span>
            </div>
        </li>
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white' "
            style="cursor: pointer"
            :style="tab_selected.aria_selected_lunas ? 'cursor: pointer;background-color:rgb(72, 107, 167)': 'cursor: pointer'"
            aria-controls="home"
            @click="tabchange('lunas')"
            :aria-selected="tab_selected.aria_selected_lunas"
          >
            Lunas
            <span class="badge ml-1 badge-success text-white">{{ total_element_lunas }}</span>
          </div>
        </li>
      </ul>
       <template v-if="role_status && role_status.status_create">
      <CButton color="success ml-auto mr-3" style="float:right" class="btn-md" @click="tambahInvoice">Tambah</CButton>
      </template>
    </div>
    <CRow>
      <CCol lg="12" class="table-responsive">
        <CDataTable style="widht:100% !important" :items="items" :fields="status_pembayaran == 'belum_lunas' ? fieldsBelumLunas: fields" hover sorter>
          <template #no="{index}">
            <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
          </template>
          <template #nominal="{item}">
            <td class="py-2">Rp.{{ item.nominal ? item.nominal : '-' }}</td>
          </template>
          <template #no_anggota="{item}">
            <td class="py-2 font-weight-bold">{{ item.no_anggota ? item.no_anggota : '-' }}</td>
          </template>
          <template #tanggal_pembayaran="{item}">
            <td class="py-2">{{ item.tanggal_pembayaran ? item.tanggal_pembayaran : "-"  }}</td>
          </template>
          <template #nama_kategori="{item}">
            <td class="py-2">{{ item.nama_kategori ? item.nama_kategori : "-"  }}</td>
          </template>
          <template #aksi="{item, index}">
            <td class="py-2 d-flex align-items-center">
               <template v-if="role_status && role_status.status_update">
              <CButton
                color="info"
                square
                size="sm"
                class="mr-1"
                @click="updateData(item, index)"
              >
                <font-awesome-icon icon="edit" />
              </CButton>&nbsp;&nbsp;
               </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
            </td>
          </template>
        </CDataTable>
        <CPagination
          style="float:right"
          :active-page.sync="currentPage"
          :pages="pagination.totalPages"
          @click="pageChange"
          responsive
        />
      </CCol>
    </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true">
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body" v-if="title == 'Tambah'">
                <div class="form-group" style="display:none">
                  <label for class="font-weight-bold">Kategori Anggota</label>            
                  <multiselect
                    class="multi-select"
                    label="namaKategori"
                    placeholder="Pilih Kategori"
                    :show-labels="false"                                        
                    id="selectKategori"
                    @select="selectKategori"
                    v-model="namaKategori"
                    :options="optionKategoriAnggota">                    
                  </multiselect>
                </div>
                <div class="form-group">
                  <label for="name" class="font-weight-bold">Nama Anggota</label>                  
                  <multiselect
                    class="multi-select"
                    placeholder="Pilih Anggota IAPI"
                    @select="selectUser"
                    v-model="multi_user"
                    :class="{
                      'has-error' : $v.formData.idUser.$error
                    }"
                    required
                    :custom-label="customLabel ? customLabel : '-'"
                    :options="dataUser">
                    <template slot="option"  slot-scope="{ option }">{{ option.no_anggota ? option.no_anggota + '-' : '' }} {{ option.nama_lengkap ?  option.nama_lengkap : 'IAPI'}}</template>
                  </multiselect>
                </div>
                <div class="form-group">
                  <label for="" class="font-weight-bold">Periode</label>
                  <multiselect
                    class="multi-select"
                    label="tahun"
                    placeholder="Pilih Periode"
                    :class="{
                      'has-error' : $v.formData.periode.$error
                    }"
                    :show-labels="false"            
                    :options="optionsPeriode"
                    v-model="periodeMulti"
                    @select="pilihPeriode"
                  ></multiselect>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <label for="member" class="font-weight-bold">Kategori Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="member" 
                      :value="multi_user.nama_kategori"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>

                  <div class="form-group col-12">
                    <label for="no_agt" class="font-weight-bold">Nama Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="no_agt"
                      placeholder="Terisi Otomatis"
                      readonly
                      :value="multi_user.nama_lengkap"

                    />
                  </div>
                  <div class="form-group col-12">                  
                    <label for="email" class="font-weight-bold">Email</label>
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      :value="multi_user.email"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="no_agt" class="font-weight-bold">Jumlah</label>
                  <input 
                  type="number" 
                  required 
                  class="form-control" 
                  min="0" 
                  id="no_agt" 
                  :class="{
                    'is-invalid' : $v.formData.nominal.$error
                  }"
                  v-model="formData.nominal" 
                  placeholder="Masukkan Jumlah" />
                </div>                
                
            </div>
            <div class="modal-body" v-else>
                <div class="form-group">
                  <label for="name" class="font-weight-bold">No. Anggota IAPI</label>                  
                  <input type="text" disabled readonly class="form-control" v-model="formData.no_anggota">
                </div>
                
                <div class="form-group">
                  <label for="name" class="font-weight-bold">Periode</label>                  
                  <input type="text" disabled readonly class="form-control" v-model="formData.periode">
                </div>

                <div class="form-row">
                  <div class="form-group col-12">
                    <label for="member" class="font-weight-bold">Kategori Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="member" 
                      :value="formData.nama_kategori ? formData.nama_kategori : '-'"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>

                  <div class="form-group col-12">
                    <label for="no_agt" class="font-weight-bold">Nama Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="no_agt"
                      placeholder="Terisi Otomatis"
                      readonly
                      :value="formData.nama_lengkap ? formData.nama_lengkap : '-'"

                    />
                  </div>
                  <div class="form-group col-12">
                  <!-- <input type="hidden" name="" v-model="formData.idUser" :value="multi_user.id_user"> -->
                    <label for="email" class="font-weight-bold">Email</label>
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      :value="formData.email ? formData.email : '-'"
                      placeholder="Terisi Otomatis"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="no_agt" class="font-weight-bold">Jumlah</label>
                  <input type="number" required class="form-control" id="no_agt" v-model="formData.nominal" placeholder="Masukkan Jumlah" />
                </div>              
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required, minLength, requiredIf, minValue } from 'vuelidate/lib/validators'

import PeriodeIuranService from "@/services/datamaster/periode-iuran.service";
import IuranPesertaService from "./../../../services/keanggotaan/iuran-anggota.service"
import DataKeanggotaanService from "./../../../services/keanggotaan/data-anggota.service"
import iuranAnggotaService from './../../../services/keanggotaan/iuran-anggota.service';
import PeriodeService from '@/services/datamaster/periode-iuran.service'
import { AlertUtils } from "../../../mixins/AlertUtils"
import { KategoriAnggota } from '@/mixins/master/KategoriAnggota'

const fields = [
  {
    key: "no",
    sorter: false,
    filter: false
  },
  {
    key: "id_invoice",
    label: "No. Invoice",
    sorter: false,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: false,
    filter: false,
    _style: "width: 16%"
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: false,
    filter: false,
    _style: "width: 15%"
  },
  {
    key: "email",
    label: "Email Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "tanggal_pembayaran",
    label: "Tanggal Pembayaran",
    sorter: false,
    filter: false
  },
  {
    key: "nominal",
    label: "Nominal Iuran",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];
const fieldsBelumLunas = [
  {
    key: "no",
    sorter: false,
    filter: false
  },
  {
    key: "id_invoice",
    label: "No. Invoice",
    sorter: false,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: false,
    filter: false,
    _style: "width: 16%"
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: false,
    filter: false,
    _style: "width: 15%"
  },
  {
    key: "email",
    label: "Email Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "nominal",
    label: "Nominal Iuran",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [
    AlertUtils,
    KategoriAnggota
  ],
  name: "laporan-iuran",
  data() {
    return {
      items: [],
      periodeMulti : [],
      namaKategori : [],
      formData: {
        idUser: "",
        nominal: "",
        periode: "",
        id_invoice: "",
        id_iuran: "",
        id_payment: ""
      },
      formFilter: {
        periode: {},
        kategori: {},
      },
      dataUser : [],
      multi_user : [
        {
          id_user : null,
          email : "",
          nama_lengkap : null,
          nama_kategori : "",
          no_anggota : ""
        }
      ],
      status_pembayaran : 'belum_lunas',
      search: "",
      items: [],
      actionPost: "",
      pageSize: 10,
      pagination: {
        totalPages: 0
      },      
      optionsPeriode: [],
      fields,
      fieldsBelumLunas,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      indexed: 0,
      tanggalStart : '',
      tanggalEnd : '',
      content: [],
      title: 'Tambah',
      total_element_lunas : 0,
      total_element_belum : 0,
      tab_selected : {
        aria_selected_lunas : false,
        aria_selected_belum_lunas : true,
        aria_selected_batal : false
      },
      get_data_status : {
        status_biaya : 'lunas'
      },
      role_status: null
    };
  },
  validations : {
    formData: {
      idUser: {required},
      nominal: {required},
      periode: {required},
    },
  },

  mounted() {    
    this.roleData();
    this.getAllDataAnggota();    
    this.getAllKategoriAnggota();
    this.getAllKategoriAnggotaFilter();
    this.getPeriode();
    this.getData("0", this.pageSize, "default", 'belum_lunas', this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
    this.getCountLunas();
    this.getCountBelum();        
  },

  watch: {
    multi_user : function(val) {
      this.formData.idUser = val.id_user
    },  
    search: function(val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {                
        vm.getData(
          "0", 
          vm.pageSize, 
          vm.search, 
          vm.status_pembayaran, 
          vm.formFilter.periode.tahun, 
          vm.formFilter.kategori.idKategoriAnggota
        );
      }, 1000);      
    },

    currentPage: function(val) {
        var page = val - 1;
        this.indexed = page * this.pageSize;
        this.getData(
          val - 1, 
          this.pageSize, 
          this.search,
          this.status_pembayaran, 
          this.formFilter.periode.tahun, 
          this.formFilter.kategori.idKategoriAnggota);
    },
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === '/keanggotaan/pengaturan-iuran' );  
        this.role_status = data;
      },
    customLabel ({no_anggota, nama_lengkap }) {
      if (no_anggota == null) {
        return `${nama_lengkap}`
      } else {
        return  `${no_anggota} - ${nama_lengkap}`
      }
    },
    
    pilihPeriode(value) {
      this.formData.periode = value.tahun
    },

    tabchange(value) {
      switch (value) {
        case 'lunas':
          this.tab_selected.aria_selected_lunas = true;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_batal = false
          this.get_data_status.status_biaya = 'lunas' 
          this.status_pembayaran = 'lunas';
          this.getData("0", this.pageSize, "default", "lunas", this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
          break;
        case 'belum_lunas':
          this.tab_selected.aria_selected_lunas = false;
          this.tab_selected.aria_selected_belum_lunas = true;
          this.tab_selected.aria_selected_batal = false
          this.get_data_status.status_biaya = 'belum_lunas'
          
          this.status_pembayaran = 'belum_lunas';
          this.getData("0", this.pageSize, "default", "belum_lunas", this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
          break;
         
        default:
          break;
      }
    },

    getCountLunas() {
      IuranPesertaService.getDataIuran(0, 1, 'default', 'lunas', this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota)
        .then(response => {          
          this.total_element_lunas = response.data.data.totalElements;        
        }).catch(error => {
          // comment console console.log(error);
        })
    },

    getCountBelum() {
      IuranPesertaService.getDataIuran(0, 1, 'default', 'belum_lunas', this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota)
      .then(response => {             
        this.total_element_belum = response.data.data.totalElements;        
      }).catch(error => {
        // comment console console.log(error);
      })
    },

    changePeriode(val) {
      // // comment console console.log(val)
      this.formData.periode = val.value.substr(0, 4);
    },

    changeKategori(val) {
      // comment console console.log(val)
    },

    selectUser(val) {
      // comment console console.log(val)
    },

    getPeriode() {
      PeriodeIuranService.getPeriode("0", 5000, "default")      
        .then(response => {
          // comment console console.log(response)
          this.optionsPeriode = response.data.data.content
        }).catch(error => {
          // comment console console.log(error)          
        })
    },

    tambahInvoice() {
      this.myModal = true
      this.formData = {};
      this.actionPost = 'insert',
      this.title = "Tambah";
      this.multi_user = {};
      this.multi_user = []
    },

    updateData(item) {
      this.myModal = true;
      this.formData = item;
      this.formData.id_invoice = item.id_invoice;
      this.formData.id_iuran_peserta = item.id_iuran_peserta;
      this.formData.id_payment = item.id_payments;
      this.actionPost = "update";
      this.title = "Edit";
    },    

    postData() {
      if (this.actionPost == "update") {
        let loader = this.$loading.show({
          container: false ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });
        
        var vm = this
        IuranPesertaService.putDataIuran(this.formData.id_invoice, this.formData.id_iuran_peserta, this.formData.id_payment, this.formData)
          .then(response => {
            vm.myModal = false;
            loader.hide()
            vm.alertEditSuccess();
            vm.getData("0", vm.pageSize, 'default', 'belum_lunas', this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
            vm.getCountLunas()
            vm.getCountBelum()
          })
          .catch(error => {
            vm.alertError(error.response.data.message);
          });
      } else {
        this.$v.formData.$touch()

        if(this.$v.formData.$invalid) {
          this.alertError("Isi Semua Data");
          return false;
        }
        let loader = this.$loading.show({
          container: false ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });

        IuranPesertaService.postDataIuran(this.formData)
          .then(response => {
            this.myModal = false;
            loader.hide()
            this.alertSuccess();
            this.getData("0", this.pageSize, "default", this.status_pembayaran, this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
            this.getCountLunas();
            this.getCountBelum();   
          }).catch(error => {
            // comment console console.log(error)
          });
      }
    },
    
    getAllDataAnggota(){
      DataKeanggotaanService.getAllDataAnggotaSemua()
        .then(response => {
          this.dataUser = response.data.data
        }).catch(error => { 
          // comment console console.log(error);
        });
    },

    selectKategori(value){
      DataKeanggotaanService.getDataAnggotaKategori(value.idKategoriAnggota)
        .then(response => {
          this.dataUser = response.data.data
        }).catch(error => { 
          // comment console console.log(error);
        });
    },

    changePageSize(e) {      
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.status_pembayaran, this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
    },

    cariData() {
      this.getData("0", this.pageSize, this.search, this.status_pembayaran, this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
    },

    pageChange() {
      
    },

    getData(currentPage, pageSize, filter, status_pembayaran, periode, kategori){  
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      IuranPesertaService.getDataIuran(currentPage, pageSize, filter, status_pembayaran, periode, kategori)
        .then(response => {
          this.items = response.data.data.content;        
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
        }).catch(error => {
          // comment console console.log(error);
          loader.hide();
        })
    },

    filterData() {
      this.getCountBelum();
      this.getCountLunas();
      this.getData("0", this.pageSize, "default", 'belum_lunas', this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
    },

    resetFilter() {
      this.formFilter = {}
    },

    deleteData(item, index) {      
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            iuranAnggotaService.deleteIuran(item.id_iuran_peserta)
            .then(response => {
              // comment console console.log(response);
              this.alertDeleteSuccess();
              this.getData("0", this.pageSize, this.search, this.status_pembayaran, this.formFilter.periode.tahun, this.formFilter.kategori.idKategoriAnggota);
            }).catch(error => {
              // comment console console.log(error);
            })
            
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
